import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, reactive } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import * as cdn from "@coredination/components";
import GroupsQuery from "@/graphql/group/groups.graphql";
import UsersQuery from "@/graphql/user/users.graphql";
import { useI18n } from "@/i18n" // in vue3: import { useI18n } from 'vue-i18n'
import router from "@/router"
import { CircularLoader, PullRefresh } from "@coredination/components"


export default /*#__PURE__*/_defineComponent({
  __name: 'UserList',
  setup(__props) {

const { t } = useI18n()

//const { onResult: groupsResult } = useQuery(GroupsQuery);
const { onResult: usersResult, loading: usersLoading, refetch: refetchUsers } = useQuery(UsersQuery);

//const groups = computed(() => groupsResult.value?.groups ?? [])
const users: any = ref([])

usersResult((result: any) => {
    if (result.data?.users) users.value = result.data.users
})

const loading = computed(() => usersLoading.value)

const refresh = async () => {
    await refetchUsers()
}

const statusText = (user: any) => {
  let text = ""
  if (user.currentJobTitle) text += user.currentJobTitle + ": "
  if (user.currentJobResourceState) text += t('resourceState_' + user.currentJobResourceState) + " | "
  //if (user.connectionState) text += t('connectionState_' + user.connectionState) // connection state is not currently updated when using worker, so the information is not useful

  if (text.endsWith(": ")) text = text.slice(0, -2)
  if (text.endsWith(" | ")) text = text.slice(0, -3)

  return text
}

const clickUser = ((user: any) => {
    if (user.uuid) router.push(`/user/${user.uuid}`)
})

const handleImageError = (user: any) => {
    const updatedUsers = users.value.map((u: any) => 
        u.id === user.id ? { ...u, avatarUrl: '' } : u
    );
    users.value = updatedUsers;
}

return { __sfc: true,t, usersResult, usersLoading, refetchUsers, users, loading, refresh, statusText, clickUser, handleImageError, CircularLoader, PullRefresh }
}

})